import React, { Component } from 'react';
import Table from "./Table";

export interface Trade
{
	date: string
	time: string
	lastPrice: string
	volume: string
	value: string
}

export interface RecentTradesProps
{
	convertValue: boolean
	trades: Trade[]
	ariaLabels?: { [key: string]: string }
	defaultTableClassName?: string
	alignRightClassName?: string
}

export default class RecentTrades extends Component<RecentTradesProps>
{
	static defaultProps = {
		alignRightClassName: 'text-align-right text-align-left-sm',
		ariaLabels: {
			date: "Date",
			time: "Time",
			price: "Price",
			quantity: "Quantity",
			value: "Value"
		}
	};

	render()
	{
		return (
			<Table
				defaultClassName={this.props.defaultTableClassName}
				theadRows={[
					<tr key="headrow-1">
						<th data-testid="dateTableHead">Date</th>
						<th data-testid="timeTableHead">Time</th>
						<th className={this.props.alignRightClassName} data-testid="priceTableHead">Price</th>
						<th className={this.props.alignRightClassName} data-testid="quantityTableHead">Quantity</th>
						<th className={this.props.alignRightClassName} data-testid="valueTableHead">{this.props.convertValue ? 'Value (£)' : 'Value'}</th>
					</tr>
				]}
				tbodyRows={
					this.props.trades.map( (trade, i) => {
						return (
							<tr key={`row-${i}`}>
								<td scope="row" aria-label={this.props.ariaLabels.date} data-testid={`dateTableValue${i}`}>{trade.date}</td>
								<td aria-label={this.props.ariaLabels.time} data-testid={`timeTableValue${i}`}>{trade.time}</td>
								<td aria-label={this.props.ariaLabels.price} className={this.props.alignRightClassName} data-testid={`priceTableValue${i}`}>{trade.lastPrice}</td>
								<td aria-label={this.props.ariaLabels.quantity} className={this.props.alignRightClassName} data-testid={`quantityTableValue${i}`}>{trade.volume}</td>
								<td aria-label={this.props.ariaLabels.value} className={this.props.alignRightClassName} data-testid={`valueTableValue${i}`}>{trade.value}</td>
							</tr>
						);
					})	
				}
			/>
		);
	}
}